// 主题配置
const themes = {
  default: {
    primary: '#1890FF',
    secondary: '#13C2C2',
    background: '#F0F2F5',
    text: '#262626',
    border: '#E8E8E8',
    cardBg: '#FFFFFF',
    success: '#67C23A',
    warning: '#E6A23C',
    danger: '#F56C6C',
    info: '#909399'
  },
  dark: {
    primary: '#316DCA',
    secondary: '#6E7681',
    background: '#0D1117',
    text: '#E6EDF3',
    border: '#30363D',
    cardBg: '#1F2329',
    success: '#3FB950',
    warning: '#F78166',
    danger: '#F85149',
    info: '#6E7681'
  },
  vibrant: {
    primary: '#FF4D4F',
    secondary: '#FF7A45',
    background: '#FFF7E6',
    text: '#262626',
    border: '#FFD591',
    cardBg: '#FFFFFF',
    success: '#52C41A',
    warning: '#FAAD14',
    danger: '#FF4D4F',
    info: '#1890FF'
  },
  natural: {
    primary: '#52C41A',
    secondary: '#95DE64',
    background: '#F6FFED',
    text: '#262626',
    border: '#B7EB8F',
    cardBg: '#FFFFFF',
    success: '#52C41A',
    warning: '#FAAD14',
    danger: '#FF4D4F',
    info: '#1890FF'
  }
};

// 切换主题
function changeTheme(themeName) {
  const theme = themes[themeName];
  if (theme) {
    Object.keys(theme).forEach(key => {
      document.documentElement.style.setProperty(`--${key}`, theme[key]);
    });
    localStorage.setItem('theme', themeName);
  }
}

// 初始化主题
function initTheme() {
  const savedTheme = localStorage.getItem('theme') || 'default';
  changeTheme(savedTheme);
  return savedTheme;
}

export { themes, changeTheme, initTheme };